import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AboutUs from "../pages/about/page";
import Activities from "../pages/activities/page";
import Applications from "../pages/applications/page";
import References from "../pages/references/page";
import Partners from "../pages/partners/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hakkimizda",
    element: <AboutUs />,
  },
  {
    path: "/faaliyetlerimiz",
    element: <Activities />,
  },
  {
    path: "/uygulamalarimiz",
    element: <Applications />,
  },
  {
    path: "/referanslarimiz",
    element: <References />,
  },
  {
    path: "/cozum-ortaklarimiz",
    element: <Partners />,
  },
  {
    path: "/iletisim",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;